import { Grid, Center, Image, Text, Box, Link } from "@chakra-ui/react";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import React from "react";
import Capture from "assets/img/Capture.PNG";

const InfoTool = () => {
  return (
    <Card>
      <CardBody mt={{sm: "0px", lg: "20px"}}>
      <Grid
            templateColumns={{ sm: "1fr", lg: "1.3fr 1.7fr" }}
            templateRows={{ sm: "1fr", lg: "1fr" }}
            gap='24px'
            mb={{ lg: "26px" }}>
            <Image src={Capture} alt='img2' order={{sm: "1", lg: "1"}}/>
            <Box fontSize="15px" order={{sm: "2", lg: "2"}}>
                <Text>This tool highlights mothers' economic contribution to the family and society through breastfeeding.</Text>
                <Text mt="10px">Potential users of this tool are policymakers, influencers, project managers, researchers, national accountants, statisticians, caregivers, and other persons supporting breastfeeding.</Text>
                <Text mt="10px">This tool was developed by the 
                  <Link color='#BE830E' target="_blank" href='https://nceph.anu.edu.au/research/projects/valuing-breastfeeding-through-mothers-milk-tool'> Australia National University</Link> and
                  <Link color='#BE830E' target="_blank" href='https://www.aliveandthrive.org'> Alive & Thrive</Link> with support from the
                  <Link color='#BE830E' target="_blank" href='https://www.fhisolutions.org/innovation-incubator/'> FHI Solutions Innovation Incubator</Link>.
                </Text>
                <Text mt="10px">Read the <Link color='#BE830E' target="_blank" href='https://nceph.anu.edu.au/files/Mothers_Milk_Tool_Information_Kit.pdf#overlay-context=news-events/events/measuring-and-valuing-womens-productivity-mothers-milk-tool'>Brief</Link></Text>
                <Text>Attend <Link color='#BE830E' target="_blank" href='https://nceph.anu.edu.au/news-events/events/measuring-and-valuing-womens-productivity-mothers-milk-tool'>Webinar</Link></Text>
                <Text>Read the <Link color='#BE830E' target="_blank" href='https://www.aliveandthrive.org/en/news/mothers-milk-contributes-almost-4-trillion-to-the-global-economy-but-its-value-has-never-been'>Commentary</Link></Text>
                <Text>Follow <Link color='#BE830E' target="_blank" href='https://twitter.com/hashtag/MothersMilkTool?src=hashtag_click'>#MothersMilkTool</Link></Text>
                <Text>Download <Link color='#BE830E' target="_blank" href='https://nceph.anu.edu.au/research/projects/valuing-breastfeeding-through-mothers-milk-tool'>Offline version</Link></Text>
            </Box>
            {/* <Center order={{sm: "1", lg: "2"}}><Image src={Capture} alt='img2' order={{sm: "1", lg: "2"}}/></Center> */}
        </Grid>
      </CardBody>
    </Card>
  );
};

export default InfoTool;
